module.exports = __webpack_public_path__ + "img/lbl02.0374ffc6.png";